module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_agreable.8a9ce26848dce341d8ad79e509b813dc.png";